export const hasAdminPermission = (user, permission) => {
  if (user?.role === 'superadmin') return true;
  if (!['admin', 'subadmin'].includes(user?.role)) return false;
  return user?.adminPermissions?.[permission] === true;
};

export const canAccessMemberManagement = (user) => [
  'passwordReset',
  'viewMember',
  'editMember',
  'membershipApproval'
].some(permission => hasAdminPermission(user, permission));

// Analytics is read-only administrative data, so it follows viewMember.
export const canAccessAnalytics = (user) => hasAdminPermission(user, 'viewMember');
